"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Icon = function Icon(_ref) {
  var kind = _ref.kind,
    group = _ref.group,
    category = _ref.category,
    file = _ref.file,
    size = _ref.size,
    color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  var formattedColor = color.replace("#", "");
  var w = size || width;
  var h = size || height;
  return _react["default"].createElement("img", {
    alt: "Icone",
    src: "https://icons.alboompro.com/v1/".concat(kind, "/").concat(group, "/").concat(category, "/").concat(formattedColor, "/").concat(file),
    width: w,
    height: h
  });
};
Icon.propTypes = {
  /** Type of stroke for the icon */
  kind: _propTypes["default"].oneOf(["bold", "light", "regular"]),
  /** Group identifier for the icon being rendered */
  group: _propTypes["default"].string.isRequired,
  /** Category identifier for the icon being rendered */
  category: _propTypes["default"].string.isRequired,
  /** Name for the icon being rendered */
  file: _propTypes["default"].string.isRequired,
  /** Width of the icon */
  width: _propTypes["default"].string,
  /** Height of the icon */
  height: _propTypes["default"].string,
  /** Easily set both widht and height of the icon using this property. If provided, it'll override valus passed in widht and height. */
  size: _propTypes["default"].string,
  /** Color for the icon, pass it as a hex color (ie: "#C1C1C1") */
  color: _propTypes["default"].string
};
Icon.defaultProps = {
  kind: "regular",
  width: "32",
  height: "32",
  size: null,
  color: "#000000"
};
var _default = Icon;
exports["default"] = _default;